export enum ExternalMemberLinkMode {
  NONE = 0,
  REGISTER = 1,
  LOGINBYMOBILENO = 2,
  LOGINBYREDIRECT = 3,
}
